// Case-insensitive, punctuation- and whitespace-tolerant name match.
// CRS names carry punctuation (e.g. "Lhe'Riise Mcmillan") that the call
// review's agent name has already turned into a space (e.g. "Lhe Riise
// Mcmillan") — so punctuation must be replaced with a space, not deleted,
// or "Lhe'Riise" would collapse to "LheRiise" and never match "Lhe Riise".
const normalizeName = (name) =>
  (name || "")
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const findAgentEmail = (agentName, emailRecipients) => {
  const normalizedAgentName = normalizeName(agentName);
  console.log("[findAgentEmail] raw agentName:", agentName, "| normalized:", normalizedAgentName);

  if (!normalizedAgentName || !Array.isArray(emailRecipients)) {
    console.log("[findAgentEmail] bailing out — no agentName or emailRecipients isn't an array");
    return null;
  }

  console.log(
    "[findAgentEmail] candidates:",
    emailRecipients.map((r) => ({ raw: r?.name, normalized: normalizeName(r?.name) }))
  );

  const match = emailRecipients.find(
    (recipient) => normalizeName(recipient?.name) === normalizedAgentName
  );

  console.log("[findAgentEmail] match:", match);

  return match ? { name: match.name, email: match.email } : null;
};

export default findAgentEmail;
